/** The wording used to build Reason for transfer from the selected invoices. */
export const TransferReason = {
    BillPayment: 'Bill payment',
    Invoice: 'Invoice',
    Invoices: 'Invoices'
} as const;
export type TransferReason = typeof TransferReason[keyof typeof TransferReason];

/** The value the API gives a bill that has no invoice number. */
export const BillReference = {
    NotAvailable: 'N/A'
} as const;
export type BillReference = typeof BillReference[keyof typeof BillReference];
